export default "__VITE_ASSET__87d8d63f__"